export default __webpack_public_path__ + "static/hiv-box@2x-dab44319beefa8d85845065c727b6f64.png";